const charToEntity = (str) => {
    const map = {
        'æ': '&aelig;', 'Æ': '&AElig;',
        'ø': '&oslash;', 'Ø': '&Oslash;',
        'å': '&aring;', 'Å': '&Aring;',
        'é': '&eacute;', 'É': '&Eacute;',
    };

    return str.replace(/[æÆøØåÅ]/g, (match) => map[match] || match);
};

export default charToEntity;
